import React, { useContext, useEffect, useState } from "react";
import api from "../../api/axios";
import {
  Box,
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  Divider,
  FormLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import {
  ArrowForwardIosOutlined,
  Close,
  Delete,
  Edit,
  Save,
  Update,
} from "@mui/icons-material";
import Swal from "sweetalert2";
import { CustomButtonPlusIcon } from "../../Components/Common/Design/CustomButtonPlusIcon";
import { PermissionContext } from "../../Components/Context/Context";
// FormFI component - Material UI
// Props:
// - initialData: object with same structure as PHP $form_FI and $form_tables (optional)
// - status: 0 = editable, 1 = readonly (matches PHP logic used in the original form)
// - onSaved: optional callback after save
// - apiBase: base URL for API endpoints (optional)
export default function FormFI({
  onSaved,
  apiBase = "",
  sectionId,
  caseId,
  nextTask,
  userLogged,
  dataCase,
  setUpdatedCase,
  updatedCase,
  activeTask,
}) {
  const { can } = useContext(PermissionContext);

  const canSignFi = can("cases", "signfi");
  const canViewFi = can("cases", "viewfi");

  //   Data inicial del backend (puede venir vacía)
  const initialData = activeTask?.config?.form_fi || {};
  const statusFlag = false;
  var status = 0;

  if (statusFlag) {
    status = activeTask?.status;
  }
  // console.log(initialData, "initialData");

  const tableConfigs = {
    table_p_cargo: {
      headers: ["Nombre", "Apellidos", "La relación de parentesco con usted"],
    },
    table_r_litigios: {
      headers: [
        "Identificación del juzgado",
        "Número de procedimiento",
        "Estado",
        "Reclamación(en euros)",
        "Demandante",
      ],
    },
    table_cuentas_bancarias: {
      headers: ["Entidad", "Oficina", "Número de cuenta", "Saldo(en euros)"],
    },
    table_titular_capital: {
      headers: [
        "Entidad",
        "Oficina",
        "Cuenta de valores",
        "Valor (en euros)",
        "A fecha",
      ],
    },
    table_titular_bienes_inmob: {
      headers: [
        "Inmueble",
        "Situación",
        "Inscripción en el Registro de la Propiedad nº,libro,folio,tomo y nº de finca",
        "Valor catastral(en euros)",
      ],
    },
    table_titular_b_i_veh_joyas: {
      headers: [
        "Tipo de bien",
        "N.º de matrícula o registro",
        "Fecha de adquisición",
      ],
    },
    table_num_acreedores: {
      headers: [
        "Identidad del acreedor",
        "Domicilio",
        "Dirección electrónica",
        "Cuantía debida",
        "Fecha de vencimiento del crédito",
        "Amortizaciones pendientes (cantidades mes/año que debe pagar)",
      ],
    },
    table_esp_ident_credito: {
      headers: [
        "Identidad del acreedor",
        "Domicilio",
        "Cuantía (*)",
        "Fecha de constitución",
        "Tipo de garantía",
      ],
    },
    table_contratos_vigor: {
      headers: [
        "Fecha de contrato",
        "Contraparte",
        "Tipo de contrato",
        "Obligaciones del deudor pendientes",
        "Obligaciones de la contraparte pendientes",
      ],
    },
    table_gastos_mens: {
      headers: [
        "Naturaleza del gasto",
        "Cuantía",
        "Fecha de vencimiento",
        "Periodicidad",
      ],
    },
    table_num_trabajadores: {
      headers: [
        "La representación de los trabajadores",
        "Domicilio del trabajador",
        "Dirección electrónica del trabajador",
      ],
    },
  };

  //   Helper para leer valores de forma segura
  // const getInit = (name, fallback = "") => {
  //   try {
  //     const value =
  //       initialData?.inputs?.find((i) => i.name === name)?.value ??
  //       initialData?.[name] ??
  //       fallback;

  //     // Evitar marcar o seleccionar opciones cuando el valor es nulo, undefined o cadena vacía
  //     if (
  //       value === null ||
  //       value === undefined ||
  //       value === "" ||
  //       value === "undefined" ||
  //       value === "null"
  //     ) {
  //       return fallback;
  //     }

  //     return value;
  //   } catch (e) {
  //     return fallback;
  //   }
  // };

  //   Helper para leer valores de forma segura
  const getInit = (name, fallback = "") => {
    try {
      const value =
        initialData?.inputs?.find((i) => i.name === name)?.value ?? fallback;

      if (
        value === null ||
        value === undefined ||
        value === "" ||
        value === "undefined" ||
        value === "null"
      ) {
        return fallback;
      }

      return value;
    } catch {
      return fallback;
    }
  };

  //   Estado principal del formulario (campos simples)
  const [form, setForm] = useState({
    nombre_completo: getInit("nombre_completo"),
    dni_cliente: getInit("dni_cliente"),
    domicilio: getInit("domicilio"),
    telefono: getInit("telefono"),
    email: getInit("email"),
    "mod_domicilia_6_m-1": getInit("mod_domicilia_6_m-1"),
    lugar_nac: getInit("lugar_nac"),
    nacionalidad: getInit("nacionalidad"),
    estado_civil: getInit("estado_civil"),
    regimen_economico: getInit("regimen_economico"),
    "ident-cony-nombre": getInit("ident-cony-nombre"),
    "ident-cony-appellidos": getInit("ident-cony-appellidos"),
    "ident-cony-dni": getInit("ident-cony-dni"),

    cony_p_v_f: getInit("cony_p_v_f"),
    cony_p_v_f_firma: getInit("cony_p_v_f_firma"),

    p_cargo: getInit("p_cargo"),

    d_p_Hecho: getInit("d_p_Hecho"),
    "ident-hecho-nombre": getInit("ident-hecho-nombre"),
    "ident-hecho-appellidos": getInit("ident-hecho-appellidos"),
    "ident-hecho-dni": getInit("ident-hecho-dni"),

    s_laboral: getInit("s_laboral"),
    d_siendo_laboral: getInit("d_siendo_laboral"),

    tipe_insolvencia: getInit("tipe_insolvencia"),
    hechos_situacion_insol: getInit("hechos_situacion_insol"),
    hechos_situ_insol_otro: getInit("hechos_situ_insol_otro"),

    memoria_exp_d: getInit("memoria_exp_d"),
    importe_g_d: getInit("importe_g_d"),
    importe_valor_b_d: getInit("importe_valor_b_d"),

    condena_10_ult: getInit("condena_10_ult"),
    condena_10_ult_delito: getInit("condena_10_ult_delito"),
    condena_10_ult_fecha: dayjs(getInit("condena_10_ult_fecha")).isValid()
      ? dayjs(getInit("condena_10_ult_fecha"))
      : "", // 🔸 vacío, no dayjs() por defecto

    acuerdo_extra_pago: getInit("acuerdo_extra_pago"),
    condena_10_ult_delit_fech: dayjs(
      getInit("condena_10_ult_delit_fech"),
    ).isValid()
      ? dayjs(getInit("condena_10_ult_delit_fech"))
      : "",

    nego_acreed_refinan: getInit("nego_acreed_refinan"),
    admitida_sol_conc_acreed: getInit("admitida_sol_conc_acreed"),

    ingresos_regular: getInit("ingresos_regular"),
    bienes_derechos: getInit("bienes_derechos"),

    cuentas_bancarias: getInit("cuentas_bancarias"),
    c_b_importe_total: getInit("c_b_importe_total"),

    titular_capital: getInit("titular_capital"),
    titular_bienes_inmob: getInit("titular_bienes_inmob"),
    "titular_b_i_veh-joyas": getInit("titular_b_i_veh-joyas"),

    num_acreedores: getInit("num_acreedores"),
    num_trabajadores: getInit("num_trabajadores"),

    credito_avalado: getInit("credito_avalado"),

    date_firma_form: getInit("date_firma_form"),
    date_edit_firma_form: getInit("date_edit_firma_form"),
  });

  //   Inicializador de tablas
  const tablesInit = (tableName, defaultRows = [], colsCount = 1) => {
    // console.log(tableName);
    try {
      const t = initialData?.tables?.find((tbl) => tbl[tableName])?.[tableName];
      if (t && Array.isArray(t) && t.length > 0) {
        //  Si hay datos en la tabla, los retornamos tal cual
        return t.map((row) =>
          Array.isArray(row)
            ? [...row] // Copia segura
            : Object.values(row ?? {}),
        );
      }

      // ⚠️ Si no hay datos pero el formulario está vacío, creamos una fila vacía
      if (defaultRows.length === 0) {
        return [Array(colsCount).fill("")];
      }

      return defaultRows;
    } catch (e) {
      return [Array(colsCount).fill("")];
    }
  };

  //   Estados de tablas (ya inicializadas con detección automática)
  const [table_p_cargo, set_table_p_cargo] = useState(
    tablesInit("table_p_cargo", [], tableConfigs.table_p_cargo.headers.length),
  );
  const [table_r_litigios, set_table_r_litigios] = useState(
    tablesInit(
      "table_r_litigios",
      [],
      tableConfigs.table_r_litigios.headers.length,
    ),
  );
  const [table_cuentas_bancarias, set_table_cuentas_bancarias] = useState(
    tablesInit(
      "table_cuentas_bancarias",
      [],
      tableConfigs.table_cuentas_bancarias.headers.length,
    ),
  );
  const [table_titular_capital, set_table_titular_capital] = useState(
    tablesInit(
      "table_titular_capital",
      [],
      tableConfigs.table_titular_capital.headers.length,
    ),
  );
  const [table_titular_bienes_inmob, set_table_titular_bienes_inmob] = useState(
    tablesInit(
      "table_titular_bienes_inmob",
      [],
      tableConfigs.table_titular_bienes_inmob.headers.length,
    ),
  );
  const [table_titular_b_i_veh_joyas, set_table_titular_b_i_veh_joyas] =
    useState(
      tablesInit(
        "table_titular_b_i_veh_joyas",
        [],
        tableConfigs.table_titular_b_i_veh_joyas.headers.length,
      ),
    );
  const [table_num_acreedores, set_table_num_acreedores] = useState(
    tablesInit(
      "table_num_acreedores",
      [],
      tableConfigs.table_num_acreedores.headers.length,
    ),
  );
  const [table_esp_ident_credito, set_table_esp_ident_credito] = useState(
    tablesInit(
      "table_esp_ident_credito",
      [],
      tableConfigs.table_esp_ident_credito.headers.length,
    ),
  );
  const [table_contratos_vigor, set_table_contratos_vigor] = useState(
    tablesInit(
      "table_contratos_vigor",
      [],
      tableConfigs.table_contratos_vigor.headers.length,
    ),
  );
  const [table_gastos_mens, set_table_gastos_mens] = useState(
    tablesInit(
      "table_gastos_mens",
      [],
      tableConfigs.table_gastos_mens.headers.length,
    ),
  );
  const [table_num_trabajadores, set_table_num_trabajadores] = useState(
    tablesInit(
      "table_num_trabajadores",
      [],
      tableConfigs.table_num_trabajadores.headers.length,
    ),
  );

  //   Función reutilizable para añadir filas
  const addRow = (setter, colsCount, defaultVals = []) => {
    if (status !== 0) return; // sólo editable si status es 0
    setter((prev) => [
      ...prev,
      defaultVals.length
        ? defaultVals.slice(0, colsCount)
        : Array(colsCount).fill(""),
    ]);
  };

  const removeRow = (setter, index) => {
    if (status !== 0) return;
    setter((prev) => prev.filter((_, i) => i !== index));
  };

  const updateCell = (setter, rowIndex, colIndex, value) => {
    setter((prev) =>
      prev.map((r, i) =>
        i === rowIndex ? r.map((c, ci) => (ci === colIndex ? value : c)) : r,
      ),
    );
  };

  // Handlers for simple inputs
  const handleChange = (name) => (e) => {
    const val = e?.target?.value ?? e;
    setForm((prev) => ({ ...prev, [name]: val }));
  };
  // Prepare payload mapping names exactly as original PHP expects
  const buildPayload = () => {
    const inputs = makeInputsArray(form); // array {name,value} como pide PHP

    //  Cambiado a array numérico de objetos (como espera PHP)
    const tables = [
      { table_num_trabajadores },
      { table_gastos_mens },
      { table_contratos_vigor },
      { table_esp_ident_credito },
      { table_num_acreedores },
      { table_titular_b_i_veh_joyas },
      { table_titular_bienes_inmob },
      { table_titular_capital },
      { table_cuentas_bancarias },
      { table_r_litigios },
      { table_p_cargo },
    ];

    return { inputs, tables };
  };
  const makeInputsArray = (formObject) => {
    // Asegura que sea un objeto
    if (typeof formObject !== "object" || formObject === null) return [];

    // Convierte el objeto en un array de { name, value }
    return Object.entries(formObject).map(([name, value]) => ({
      name,
      value,
    }));
  };

  // API functions (you said you'll wire endpoints) - examples
  const saveDraft = async () => {
    const confirmResult = await Swal.fire({
      title: "¿Guardar borrador?",
      text: "¿Deseas guardar los cambios como borrador?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, guardar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    });

    if (!confirmResult.isConfirmed) return;

    try {
      //  Mostrar alerta de carga
      Swal.fire({
        title: "Guardando...",
        text: "Por favor espera mientras se guarda el borrador.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const now = new Date().toISOString().slice(0, 19).replace("T", " ");
      setForm((prev) => ({
        ...prev,
        date_edit_firma_form: `Fecha última modificación: ${now}`,
      }));

      const formDataTask = new FormData();
      formDataTask.append("current_task", activeTask?.id || 0);

      const config = { form_fi: buildPayload() };
      formDataTask.append("config", JSON.stringify(config));

      const url = `${process.env.REACT_APP_API_URL}/casestasks/updatetasks`;

      const res = await api.post(url, formDataTask);
      console.log(res);
      setUpdatedCase(!updatedCase);

      //  Cerrar el Swal de carga antes de mostrar el de éxito
      Swal.close();

      //  Swal de guardado exitoso
      await Swal.fire({
        icon: "success",
        title: "¡Borrador guardado!",
        text: "Los cambios se han guardado correctamente como borrador.",
        confirmButtonColor: "#1ab394",
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      });

      return res.data;
    } catch (error) {
      console.error("saveDraft error", error);

      Swal.close(); // Cierra cualquier Swal activo
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: "Ocurrió un problema al guardar el borrador.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const submitForm = async () => {
    const confirmResult = await Swal.fire({
      title: "¿Enviar formulario?",
      text: "¿Deseas presentar definitivamente este formulario?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, enviar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    });

    if (!confirmResult.isConfirmed) return;

    // Mostrar indicador de carga
    try {
      const now = new Date().toISOString().slice(0, 19).replace("T", " ");
      setForm((prev) => ({
        ...prev,
        date_edit_firma_form: `Fecha última modificación: ${now}`,
        date_firma_form: `Presentado con fecha: ${now}`,
      }));

      const config = { form_fi: buildPayload() };

      await nextTask(config, 1, "next", "");
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al enviar",
        text: "Ocurrió un problema al enviar el formulario.",
      });
    }
  };

  // Triple-check routine: basic validation ensuring all expected fields exist
  const recheckAllFieldsExist = () => {
    const expectedSimple = [
      "nombre_completo",
      "dni_cliente",
      "domicilio",
      "telefono",
      "email",
      "mod_domicilia_6_m-1",
      "lugar_nac",
      "nacionalidad",
      "estado_civil",
      "regimen_economico",
      "ident-cony-nombre",
      "ident-cony-appellidos",
      "ident-cony-dni",
      "cony_p_v_f",
      "cony_p_v_f_firma",
      "p_cargo",
      "d_p_Hecho",
      "ident-hecho-nombre",
      "ident-hecho-appellidos",
      "ident-hecho-dni",
      "s_laboral",
      "d_siendo_laboral",
      "tipe_insolvencia",
      "hechos_situacion_insol",
      "hechos_situ_insol_otro",
      "memoria_exp_d",
      "importe_g_d",
      "importe_valor_b_d",
      "condena_10_ult",
      "condena_10_ult_delito",
      "condena_10_ult_fecha",
      "acuerdo_extra_pago",
      "condena_10_ult_delit_fech",
      "nego_acreed_refinan",
      "admitida_sol_conc_acreed",
      "ingresos_regular",
      "bienes_derechos",
      "cuentas_bancarias",
      "c_b_importe_total",
      "titular_capital",
      "titular_bienes_inmob",
      "titular_b_i_veh-joyas",
      "num_acreedores",
      "num_trabajadores",
      "credito_avalado",
      "date_firma_form",
      "date_edit_firma_form",
    ];
    const missing = expectedSimple.filter(
      (k) => !(k in form) && k !== "date_edit_firma_form",
    );
    // date_edit can be empty until edit
    return { missing, tablesCount: Object.keys(buildPayload().tables).length };
  };

  // Render helpers for table UIs - generic table with add/remove
  const renderTable = (title, headers, rows, setRows, editable = true) => {
    // console.log(headers);
    return (
      <Paper variant="outlined" sx={{ p: 1, mb: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}>
          <Typography variant="subtitle1" sx={{ maxWidth: "80%" }}>
            {title}
          </Typography>
          {editable && status === 0 && (
            <CustomButtonPlusIcon
              aria={`add-${title}`}
              variant="outlined"
              color="success"
              position="end"
              size="small"
              icon={AddIcon}
              handleFunction={() => addRow(setRows, headers.length)}
              text={"Añadir fila"}
            />
          )}
        </Box>
        <Table size="small">
          <TableHead>
            <TableRow>
              {headers.map((h, i) => (
                <TableCell key={i}>{h}</TableCell>
              ))}
              {editable && status === 0 && <TableCell>Acciones</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r, ri) => (
              <TableRow key={ri}>
                {r.map((c, ci) => {
                  // 🔍 Detecta si la columna actual es una fecha
                  const isDateColumn = /fecha/i.test(headers[ci]);
                  return (
                    <TableCell key={ci}>
                      {isDateColumn ? (
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale="es">
                          <DesktopDatePicker
                            value={dayjs(c).isValid() ? dayjs(c) : dayjs()}
                            onChange={(newValue) =>
                              updateCell(setRows, ri, ci, newValue)
                            }
                            disabled={status !== 0}
                            slotProps={{
                              textField: { size: "small", fullWidth: true },
                            }}
                          />
                        </LocalizationProvider>
                      ) : (
                        <TextField
                          size="small"
                          value={c ?? ""}
                          onChange={(e) =>
                            updateCell(setRows, ri, ci, e.target.value)
                          }
                          fullWidth
                          disabled={status !== 0}
                        />
                      )}
                    </TableCell>
                  );
                })}
                {editable && status === 0 && (
                  <TableCell sx={{ textAlign: "center" }}>
                    <IconButton
                      size="small"
                      sx={(theme) => ({
                        border: `1px solid ${theme.palette.error.main}`,
                        borderRadius: "4px",
                      })}
                      onClick={() => removeRow(setRows, ri)}>
                      <Close fontSize="small" color="error" />
                    </IconButton>
                  </TableCell>
                )}
              </TableRow>
            ))}
            {rows.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={headers.length + (editable && status === 0 ? 1 : 0)}>
                  <Typography variant="body2">No hay filas</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    );
  };

  //DESCARGAR PDF
  const handleDownloadPDF = async () => {
    const formElement = document.getElementById("content_form_fi");
    if (!formElement) return;

    try {
      Swal.fire({
        title: "Generando PDF...",
        text: "Por favor espera un momento",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      //  Capturar el formulario como imagen
      const canvas = await html2canvas(formElement, {
        scale: 2, // mantiene buena calidad
        useCORS: true,
        backgroundColor: "#fff",
      });

      const imgData = canvas.toDataURL("image/png");

      //  Usar el tamaño real del formulario (en píxeles)
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;

      // Convertir de píxeles a puntos (1 punto = 1/72 pulgadas, 1 pulgada ≈ 96 píxeles)
      const pxToPt = (px) => (px * 72) / 96;

      //  Crear PDF con el mismo tamaño que el formulario
      const pdfWidth = pxToPt(imgWidth);
      const pdfHeight = pxToPt(imgHeight);

      const pdfDoc = await PDFDocument.create();
      const page = pdfDoc.addPage([pdfWidth, pdfHeight]);

      //  Insertar la imagen del formulario
      const pngImage = await pdfDoc.embedPng(imgData);

      page.drawImage(pngImage, {
        x: 0,
        y: 0,
        width: pdfWidth,
        height: pdfHeight,
      });

      //  Guardar y descargar
      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      saveAs(blob, "formularioFI.pdf");

      Swal.fire({
        icon: "success",
        title: "PDF generado",
        text: "El archivo se ha descargado correctamente",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al generar el PDF",
        text: error.message || "Ocurrió un problema al crear el documento.",
      });
    }
  };

  //DESCARGAR PDF

  useEffect(() => {
    // initial recheck - user requested triple-check
    const check1 = recheckAllFieldsExist();
    const check2 = recheckAllFieldsExist();
    const check3 = recheckAllFieldsExist();
    // basic console log - caller can inspect
    console.log("FormFI recheck results", { check1, check2, check3 });
  }, []);

  //   Agregar filas automáticamente si las tablas traen datos desde initialData
  useEffect(() => {
    if (!initialData?.tables) return;

    const autoFill = (tableName, setter, currentTable) => {
      const data = tablesInit(tableName, []);
      // solo actualizar si vienen datos y no están ya en el estado
      if (Array.isArray(data) && data.length > 0 && currentTable.length === 0) {
        setter(data);
      }
    };

    autoFill("table_p_cargo", set_table_p_cargo, table_p_cargo);
    autoFill("table_r_litigios", set_table_r_litigios, table_r_litigios);
    autoFill(
      "table_cuentas_bancarias",
      set_table_cuentas_bancarias,
      table_cuentas_bancarias,
    );
    autoFill(
      "table_titular_capital",
      set_table_titular_capital,
      table_titular_capital,
    );
    autoFill(
      "table_titular_bienes_inmob",
      set_table_titular_bienes_inmob,
      table_titular_bienes_inmob,
    );
    autoFill(
      "table_titular_b_i_veh_joyas",
      set_table_titular_b_i_veh_joyas,
      table_titular_b_i_veh_joyas,
    );
    autoFill(
      "table_num_acreedores",
      set_table_num_acreedores,
      table_num_acreedores,
    );
    autoFill(
      "table_esp_ident_credito",
      set_table_esp_ident_credito,
      table_esp_ident_credito,
    );
    autoFill(
      "table_contratos_vigor",
      set_table_contratos_vigor,
      table_contratos_vigor,
    );
    autoFill("table_gastos_mens", set_table_gastos_mens, table_gastos_mens);
    autoFill(
      "table_num_trabajadores",
      set_table_num_trabajadores,
      table_num_trabajadores,
    );
  }, []);

  return (
    <Box component="form" id="content_form_fi" p={"20px"}>
      {canViewFi && (
        <Grid container sx={{ "& > *": { p: "5px" }, fontSize: "14px" }}>
          <Grid
            container
            sx={{
              background: "#0288d10f",
              "& > *": { p: "10px" },
            }}>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                fullWidth
                label="Nombre"
                name="nombre_completo"
                value={form?.nombre_completo ?? ""}
                onChange={handleChange("nombre_completo")}
                disabled={status !== 0}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                fullWidth
                label="Dni"
                name="dni_cliente"
                value={form?.dni_cliente ?? ""}
                onChange={handleChange("dni_cliente")}
                disabled={status !== 0}
              />
            </Grid>
            <Grid item xs={12}>
              <b>
                Actuando en nombre propio, declaro que la estimación inicial del
                pasivo no supera la cantidad de cinco millones de euros.
              </b>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1">DATOS PERSONALES</Typography>
          </Grid>
          <Grid
            container
            sx={{
              "& > *": { p: "5px" },
            }}>
            <Divider sx={{ width: "100%", my: "5px", p: 0 }} />
            <Typography
              sx={{ background: "#0288d10f", width: "100%" }}
              variant="subtitle2">
              A. IDENTIFICACIÓN
            </Typography>
            <Divider sx={{ width: "100%", my: "5px", p: 0 }} />

            <Grid
              container
              sx={{
                "& > *": { p: "5px" },
              }}>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  label="1. Domicilio con dirección completa"
                  name="domicilio"
                  value={form?.domicilio ?? ""}
                  onChange={handleChange("domicilio")}
                  disabled={status !== 0}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  fullWidth
                  label="2. Teléfono"
                  name="telefono"
                  value={form?.telefono ?? ""}
                  onChange={handleChange("telefono")}
                  disabled={status !== 0}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  fullWidth
                  label="3. Correo electrónico"
                  name="email"
                  value={form?.email ?? ""}
                  onChange={handleChange("email")}
                  disabled={status !== 0}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  4. Modificación del domicilio en los últimos seis meses
                  (marcar Si o No donde proceda):
                </Typography>
                <RadioGroup
                  row
                  value={form["mod_domicilia_6_m-1"] ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      "mod_domicilia_6_m-1": e.target.value,
                    }))
                  }>
                  <FormControlLabel
                    value="Si"
                    control={<Radio />}
                    label="Si"
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={status !== 0}
                  />
                </RadioGroup>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  fullWidth
                  label="5. Lugar de nacimiento"
                  name="lugar_nac"
                  value={form?.lugar_nac ?? ""}
                  onChange={handleChange("lugar_nac")}
                  disabled={status !== 0}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  fullWidth
                  label="6. Nacionalidad (en caso de extranjería)"
                  name="nacionalidad"
                  value={form?.nacionalidad ?? ""}
                  onChange={handleChange("nacionalidad")}
                  disabled={status !== 0}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="estado_civil_label" size="small">
                    7. Estado civil
                  </InputLabel>
                  <Select
                    labelId="estado_civil_label"
                    label="7. Estado civil"
                    value={form?.estado_civil ?? ""}
                    onChange={handleChange("estado_civil")}
                    disabled={status !== 0}>
                    <MenuItem value="">Ninguna opción</MenuItem>
                    <MenuItem value="soltero">soltero</MenuItem>
                    <MenuItem value="casado (con convenio regulador)">
                      casado (con convenio regulador)
                    </MenuItem>
                    <MenuItem value="casado (sin convenio regulador)">
                      casado (sin convenio regulador)
                    </MenuItem>
                    <MenuItem value="separado">separado</MenuItem>
                    <MenuItem value="divorciado">divorciado</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="regimen_economico_label" size="small">
                    8. Régimen económico matrimonial
                  </InputLabel>
                  <Select
                    labelId="regimen_economico_label"
                    label="8. Régimen económico matrimonial"
                    value={form?.regimen_economico ?? ""}
                    onChange={handleChange("regimen_economico")}
                    disabled={status !== 0}>
                    <MenuItem value="">Ninguna opción</MenuItem>
                    <MenuItem value="Gananciales">Gananciales</MenuItem>
                    <MenuItem value="Separación de bienes">
                      Separación de bienes
                    </MenuItem>
                    <MenuItem value="Participación">Participación</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography>9. Identidad del cónyuge</Typography>
                <Grid container spacing={1} sx={{ mt: "5px" }}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Nombre Cónyuge"
                      value={form["ident-cony-nombre"] ?? ""}
                      onChange={handleChange("ident-cony-nombre")}
                      disabled={status !== 0}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Apellidos Cónyuge"
                      value={form["ident-cony-appellidos"] ?? ""}
                      onChange={handleChange("ident-cony-appellidos")}
                      disabled={status !== 0}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      size="small"
                      fullWidth
                      label="NIF/NIE/ Pasaporte Cónyuge"
                      value={form["ident-cony-dni"] ?? ""}
                      onChange={handleChange("ident-cony-dni")}
                      disabled={status !== 0}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  10. Indicar si los cónyuges son propietarios de vivienda
                  familiar que pueda verse afectada.
                </Typography>
                <RadioGroup
                  row
                  value={form?.cony_p_v_f ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({ ...prev, cony_p_v_f: e.target.value }))
                  }>
                  <FormControlLabel
                    value="Si"
                    control={<Radio />}
                    label="Si"
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={status !== 0}
                  />
                </RadioGroup>
              </Grid>

              {form?.cony_p_v_f === "Si" && (
                <Grid item xs={12}>
                  <Typography>En caso afirmativo:</Typography>
                  <RadioGroup
                    value={form?.cony_p_v_f_firma ?? ""}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        cony_p_v_f_firma: e.target.value,
                      }))
                    }>
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Se acompaña el consentimiento del otro cónyuge."
                      disabled={status !== 0}
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio />}
                      label="La solicitud se firma por parte ambos cónyuges."
                      disabled={status !== 0}
                    />
                  </RadioGroup>
                </Grid>
              )}

              <Grid item xs={12}>
                <Typography>
                  11. Personas a su cargo o a quienes deba satisfacer alimentos.
                </Typography>
                <RadioGroup
                  row
                  value={form?.p_cargo ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({ ...prev, p_cargo: e.target.value }))
                  }>
                  <FormControlLabel
                    value="Si"
                    control={<Radio />}
                    label="Si"
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={status !== 0}
                  />
                </RadioGroup>
              </Grid>

              {form?.p_cargo === "Si" && (
                <Grid item xs={12}>
                  {renderTable(
                    "Personas a su cargo",
                    tableConfigs.table_p_cargo.headers,
                    table_p_cargo,
                    set_table_p_cargo,
                    true,
                  )}
                </Grid>
              )}

              <Grid item xs={12}>
                <Typography>
                  12. Indicar si el deudor tiene pareja de hecho con la que haya
                  formado un patrimonio común y los pactos o reglas económicas
                  que le sean de aplicación.
                </Typography>
                <RadioGroup
                  row
                  value={form?.d_p_Hecho ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({ ...prev, d_p_Hecho: e.target.value }))
                  }>
                  <FormControlLabel
                    value="Si"
                    control={<Radio />}
                    label="Si"
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={status !== 0}
                  />
                </RadioGroup>
              </Grid>

              {form?.d_p_Hecho === "Si" && (
                <>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Nombre pareja de Hecho"
                      value={form["ident-hecho-nombre"] ?? ""}
                      onChange={handleChange("ident-hecho-nombre")}
                      disabled={status !== 0}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Apellidos pareja de Hecho"
                      value={form["ident-hecho-appellidos"] ?? ""}
                      onChange={handleChange("ident-hecho-appellidos")}
                      disabled={status !== 0}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      size="small"
                      fullWidth
                      label="NIF/NIE/ Pasaporte pareja de Hecho"
                      value={form["ident-hecho-dni"] ?? ""}
                      onChange={handleChange("ident-hecho-dni")}
                      disabled={status !== 0}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12}>
                <Typography>13. Indicar su situación laboral</Typography>
                <RadioGroup
                  value={form?.s_laboral ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({ ...prev, s_laboral: e.target.value }))
                  }>
                  <FormControlLabel
                    value="2"
                    control={<Radio />}
                    label="Trabaja por cuenta ajena en la actualidad."
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="Trabaja como Autónomo"
                    disabled={status !== 0}
                  />
                </RadioGroup>
              </Grid>

              <Grid item xs={12}>
                <Typography>
                  14. Indique si la mayoría de las deudas se originaron siendo:
                </Typography>
                <RadioGroup
                  value={form?.d_siendo_laboral ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      d_siendo_laboral: e.target.value,
                    }))
                  }>
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="Autónomo"
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio />}
                    label="Trabajador por cuenta ajena"
                    disabled={status !== 0}
                  />
                </RadioGroup>
              </Grid>
            </Grid>

            <Divider sx={{ width: "100%", my: "5px", p: 0 }} />
            <Typography
              sx={{ background: "#0288d10f", width: "100%" }}
              variant="subtitle2">
              B. CONCURRENCIA DE LAS CONDICIONES DE ACCESO AL PROCEDIMIENTO.
            </Typography>
            <Divider sx={{ width: "100%", my: "5px", p: 0 }} />

            <Grid item xs={12}>
              <Typography>
                1. Señale el tipo de insolvencia en que se encuentra:
              </Typography>
              <RadioGroup
                value={form?.tipe_insolvencia ?? ""}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    tipe_insolvencia: e.target.value,
                  }))
                }>
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="Actual, si ya no puede cumplir regularmente sus obligaciones exigibles."
                  disabled={status !== 0}
                />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Inminente, si prevé que no podrá cumplir regular y puntualmente sus obligaciones."
                  disabled={status !== 0}
                />
              </RadioGroup>

              <Box sx={{ mt: 1 }}>
                <FormControl fullWidth>
                  <InputLabel id="hechos_situacion_insol_label" size="small">
                    2. Indique los hechos de los que deriva su situación de
                    insolvencia
                  </InputLabel>
                  <Select
                    labelId="hechos_situacion_insol_label"
                    label={
                      "3. Indique los hechos de los que deriva su situación de insolvencia"
                    }
                    value={form?.hechos_situacion_insol ?? ""}
                    onChange={handleChange("hechos_situacion_insol")}
                    disabled={status !== 0}>
                    <MenuItem value="">Ninguna opción</MenuItem>
                    <MenuItem value="Desempleo.">Desempleo.</MenuItem>
                    <MenuItem value="Sobreendeudamiento.">
                      Sobreendeudamiento.
                    </MenuItem>
                    <MenuItem value="Pérdidas empresariales o profesionales.">
                      Pérdidas empresariales o profesionales.
                    </MenuItem>
                    <MenuItem value="Disminución de las ventas.">
                      Disminución de las ventas.
                    </MenuItem>
                    <MenuItem value="Aumento de los gastos de explotación.">
                      Aumento de los gastos de explotación.
                    </MenuItem>
                    <MenuItem value="Aumento de los costes financieros.">
                      Aumento de los costes financieros.
                    </MenuItem>
                    <MenuItem value="Aumento de la morosidad de los clientes.">
                      Aumento de la morosidad de los clientes.
                    </MenuItem>
                    <MenuItem value="Otros">Otros</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              {form?.hechos_situacion_insol === "Otros" && (
                <Box sx={{ mt: 1 }}>
                  <FormControl style={{ width: "100%" }}>
                    <FormLabel sx={{ textAlign: "left" }}>
                      3. Indique cuales el hecho de insolvencia (Otro)
                    </FormLabel>
                    <textarea
                      style={{
                        resize: "none",
                        padding: "10px 13px",
                        fontSize: "15px",
                        borderRadius: "4px",
                        border: "1px solid rgba(128, 128, 128, 0.35)",
                      }}
                      rows={5}
                      disabled={status !== 0}
                      onChange={handleChange("hechos_situ_insol_otro")}
                      value={form?.hechos_situ_insol_otro ?? ""}
                    />
                  </FormControl>
                </Box>
              )}

              <Box sx={{ mt: 1 }}>
                <FormControl style={{ width: "100%" }}>
                  <FormLabel sx={{ textAlign: "left" }}>
                    Memoria explicativa del origen de las deudas
                  </FormLabel>
                  <textarea
                    rows={5}
                    style={{
                      resize: "none",
                      padding: "10px 13px",
                      fontSize: "15px",
                      borderRadius: "4px",
                      border: "1px solid rgba(128, 128, 128, 0.35)",
                    }}
                    disabled={status !== 0}
                    onChange={handleChange("memoria_exp_d")}
                    value={form?.memoria_exp_d ?? ""}
                  />
                </FormControl>
              </Box>

              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    fullWidth
                    label="4. Estimación del importe global de las deudas"
                    value={form?.importe_g_d ?? ""}
                    onChange={handleChange("importe_g_d")}
                    disabled={status !== 0}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    fullWidth
                    label="5. Estimación del importe global del valor de los bienes y derechos"
                    value={form?.importe_valor_b_d ?? ""}
                    onChange={handleChange("importe_valor_b_d")}
                    disabled={status !== 0}
                  />
                </Grid>
              </Grid>

              <Box sx={{ mt: 2 }}>
                <Typography>
                  6. Indique si ha sido condenado en sentencia firme por delito
                  contra el patrimonio, contra el orden socioeconómico, de
                  falsedad documental, contra la Hacienda Pública, la Seguridad
                  Social o contra los derechos de los trabajadores en los 10
                  años anteriores:
                </Typography>
                <RadioGroup
                  row
                  value={form?.condena_10_ult ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      condena_10_ult: e.target.value,
                    }))
                  }>
                  <FormControlLabel
                    value="Si"
                    control={<Radio />}
                    label="Si"
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={status !== 0}
                  />
                </RadioGroup>

                {form?.condena_10_ult === "Si" && (
                  <Box sx={{ mt: 1 }}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Especifique el delito por el que fue condenado"
                      value={form?.condena_10_ult_delito ?? ""}
                      onChange={handleChange("condena_10_ult_delito")}
                      disabled={status !== 0}
                    />
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="es">
                      <DesktopDatePicker
                        value={
                          dayjs(form?.condena_10_ult_fecha).isValid()
                            ? dayjs(form?.condena_10_ult_fecha)
                            : (dayjs() ?? null)
                        }
                        id={"date-id"}
                        label={
                          "La fecha de la sentencia firme en virtud de la cual hubiera sido condenado"
                        }
                        onChange={handleChange("condena_10_ult_fecha")}
                        disabled={status !== 0}
                        sx={{ width: "100%", mt: "10px" }}
                      />
                    </LocalizationProvider>
                  </Box>
                )}

                <Box sx={{ mt: 2 }}>
                  <Typography>
                    7. Indique si ha alcanzado un acuerdo extrajudicial de pagos
                    con los acreedores, ha obtenido la homologación de un
                    acuerdo extrajudicial de refinanciación o ha sido declarado
                    en concurso de acreedores dentro de los últimos 5 años.
                  </Typography>
                  <RadioGroup
                    row
                    value={form?.acuerdo_extra_pago ?? ""}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        acuerdo_extra_pago: e.target.value,
                      }))
                    }>
                    <FormControlLabel
                      value="Si"
                      control={<Radio />}
                      label="Si"
                      disabled={status !== 0}
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                      disabled={status !== 0}
                    />
                  </RadioGroup>

                  {form?.acuerdo_extra_pago === "Si" && (
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="es">
                      <DesktopDatePicker
                        value={
                          dayjs(form?.condena_10_ult_delit_fech).isValid()
                            ? dayjs(form?.condena_10_ult_delit_fech)
                            : (dayjs() ?? null)
                        }
                        id={"date-id"}
                        label={"Fecha del acuerdo/auto"}
                        onChange={handleChange("condena_10_ult_delit_fech")}
                        disabled={status !== 0}
                        sx={{ width: "100%", mt: "10px" }}
                      />
                    </LocalizationProvider>
                  )}
                </Box>

                <Box sx={{ mt: 2 }}>
                  <Typography>
                    8. Indique si actualmente se encuentra USTED negociando con
                    sus acreedores un acuerdo de refinanciación.
                  </Typography>
                  <RadioGroup
                    row
                    value={form?.nego_acreed_refinan ?? ""}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        nego_acreed_refinan: e.target.value,
                      }))
                    }>
                    <FormControlLabel
                      value="Si"
                      control={<Radio />}
                      label="Si"
                      disabled={status !== 0}
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                      disabled={status !== 0}
                    />
                  </RadioGroup>
                </Box>

                <Box sx={{ mt: 2 }}>
                  <Typography>
                    9. Indique si actualmente se encuentra admitida respecto de
                    Ud. una solicitud de concurso de acreedores.
                  </Typography>
                  <RadioGroup
                    row
                    value={form?.admitida_sol_conc_acreed ?? ""}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        admitida_sol_conc_acreed: e.target.value,
                      }))
                    }>
                    <FormControlLabel
                      value="Si"
                      control={<Radio />}
                      label="Si"
                      disabled={status !== 0}
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                      disabled={status !== 0}
                    />
                  </RadioGroup>
                </Box>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Typography>
                  10. Relacione los litigios en curso (si los hay):
                </Typography>
                {renderTable(
                  "Tabla Litigios",
                  tableConfigs.table_r_litigios.headers,
                  table_r_litigios,
                  set_table_r_litigios,
                  true,
                )}
              </Box>
            </Grid>

            <Divider sx={{ width: "100%", my: "5px", p: 0 }} />
            <Typography
              sx={{ background: "#0288d10f", width: "100%" }}
              variant="subtitle2">
              C. INVENTARIO DE BIENES Y DERECHOS.
            </Typography>
            <Divider sx={{ width: "100%", my: "5px", p: 0 }} />

            <Grid item xs={12}>
              <FormControl style={{ width: "100%", mt: 1 }}>
                <FormLabel sx={{ textAlign: "left", marginTop: 1 }}>
                  1. Indique la relación de ingresos regulares previstos,
                  bienes, derechos y cualquier otro activo líquido de los que
                  sea titular el deudor y/o su cónyuge.
                </FormLabel>
                <textarea
                  rows={3}
                  style={{
                    resize: "none",
                    padding: "10px 13px",
                    fontSize: "15px",
                    borderRadius: "4px",
                    border: "1px solid rgba(128, 128, 128, 0.35)",
                  }}
                  disabled={status !== 0}
                  onChange={handleChange("ingresos_regular")}
                  value={form?.ingresos_regular ?? ""}
                />
              </FormControl>
              <FormControl style={{ width: "100%", mt: 1 }}>
                <FormLabel sx={{ textAlign: "left", marginTop: 1 }}>
                  2. Si procede, indique los bienes y derechos necesarios para
                  la continuación de su actividad profesional o empresarial
                </FormLabel>
                <textarea
                  rows={2}
                  style={{
                    resize: "none",
                    padding: "10px 13px",
                    fontSize: "15px",
                    borderRadius: "4px",
                    border: "1px solid rgba(128, 128, 128, 0.35)",
                  }}
                  disabled={status !== 0}
                  onChange={handleChange("bienes_derechos")}
                  value={form?.bienes_derechos ?? ""}
                />
              </FormControl>

              <Box sx={{ mt: 2 }}>
                <Typography>
                  3. Indique si es titular de cuentas bancarias.
                </Typography>
                <RadioGroup
                  row
                  value={form?.cuentas_bancarias ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      cuentas_bancarias: e.target.value,
                    }))
                  }>
                  <FormControlLabel
                    value="Si"
                    control={<Radio />}
                    label="Si"
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={status !== 0}
                  />
                </RadioGroup>
              </Box>

              {form?.cuentas_bancarias === "Si" && (
                <Box sx={{ mt: 1 }}>
                  <TextField
                    size="small"
                    label="Importe total del dinero depositado"
                    value={form?.c_b_importe_total ?? ""}
                    onChange={handleChange("c_b_importe_total")}
                    disabled={status !== 0}
                    fullWidth
                  />
                  {renderTable(
                    "Cuentas bancarias",
                    tableConfigs.table_cuentas_bancarias.headers,
                    table_cuentas_bancarias,
                    set_table_cuentas_bancarias,
                    true,
                  )}
                </Box>
              )}

              <Box sx={{ mt: 2 }}>
                <Typography>
                  4. Indique si es titular de capital mobiliario (acciones,
                  obligaciones, cuentas corrientes, depósitos financieros,
                  seguros, arrendamiento de bienes muebles).
                </Typography>
                <RadioGroup
                  row
                  value={form?.titular_capital ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      titular_capital: e.target.value,
                    }))
                  }>
                  <FormControlLabel
                    value="Si"
                    control={<Radio />}
                    label="Si"
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={status !== 0}
                  />
                </RadioGroup>
                {form?.titular_capital === "Si" &&
                  renderTable(
                    "Titular capital",
                    tableConfigs.table_titular_capital.headers,
                    table_titular_capital,
                    set_table_titular_capital,
                    true,
                  )}
              </Box>

              <Box sx={{ mt: 2 }}>
                <Typography>
                  5. Indique si es titular de bienes inmuebles
                </Typography>
                <RadioGroup
                  row
                  value={form?.titular_bienes_inmob ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      titular_bienes_inmob: e.target.value,
                    }))
                  }>
                  <FormControlLabel
                    value="Si"
                    control={<Radio />}
                    label="Si"
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={status !== 0}
                  />
                </RadioGroup>
                {form?.titular_bienes_inmob === "Si" &&
                  renderTable(
                    "Titular bienes inmuebles",
                    tableConfigs.table_titular_bienes_inmob.headers,
                    table_titular_bienes_inmob,
                    set_table_titular_bienes_inmob,
                    true,
                  )}
              </Box>

              <Box sx={{ mt: 2 }}>
                <Typography>
                  6. Indique si es titular de bienes muebles (vehículos, joyas,
                  obras de arte…)
                </Typography>
                <RadioGroup
                  row
                  value={form["titular_b_i_veh-joyas"] ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      "titular_b_i_veh-joyas": e.target.value,
                    }))
                  }>
                  <FormControlLabel
                    value="Si"
                    control={<Radio />}
                    label="Si"
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={status !== 0}
                  />
                </RadioGroup>
                {form["titular_b_i_veh-joyas"] === "Si" &&
                  renderTable(
                    "Titular bienes muebles",
                    tableConfigs.table_titular_b_i_veh_joyas.headers,
                    table_titular_b_i_veh_joyas,
                    set_table_titular_b_i_veh_joyas,
                    true,
                    "date",
                  )}
              </Box>
            </Grid>

            <Divider sx={{ width: "100%", my: "5px", p: 0 }} />
            <Typography
              sx={{ background: "#0288d10f", width: "100%" }}
              variant="subtitle2">
              D. LISTA DE ACREEDORES.
            </Typography>
            <Divider sx={{ width: "100%", my: "5px", p: 0 }} />

            <Grid item xs={12}>
              <TextField
                size="small"
                label="1. Número de acreedores"
                value={form?.num_acreedores ?? ""}
                onChange={handleChange("num_acreedores")}
                disabled={status !== 0}
                fullWidth
                sx={{ mb: 1 }}
              />

              {renderTable(
                "2. Datos identificativos de los acreedores",
                tableConfigs.table_num_acreedores.headers,
                table_num_acreedores,
                set_table_num_acreedores,
                true,
              )}

              {renderTable(
                "3. Especialidades de identificación de créditos que dispongan de hipoteca o garantías reales (debe acompañarse original o copia autorizada de la escritura de constitución de las garantías o certificación registral de inscripción en el caso de la hipoteca).",
                tableConfigs.table_esp_ident_credito.headers,
                table_esp_ident_credito,
                set_table_esp_ident_credito,
                true,
              )}

              {renderTable(
                "4. Relación de los contratos en vigor de los que sea acreedor(debe acompañarse contrato original o copia fehaciente del mismo).",
                tableConfigs.table_contratos_vigor.headers,
                table_contratos_vigor,
                set_table_contratos_vigor,
                true,
              )}

              {renderTable(
                "5. Relación de gastos mensuales previstos",
                tableConfigs.table_gastos_mens.headers,
                table_gastos_mens,
                set_table_gastos_mens,
                true,
              )}

              <TextField
                size="small"
                label="6. Número de trabajadores"
                value={form?.num_trabajadores ?? ""}
                onChange={handleChange("num_trabajadores")}
                disabled={status !== 0}
                fullWidth
                sx={{ mt: 2 }}
              />

              {renderTable(
                "Indicar si tiene contratados trabajadores a su cargo",
                tableConfigs.table_num_trabajadores.headers,
                table_num_trabajadores,
                set_table_num_trabajadores,
                true,
              )}

              <Box sx={{ mt: 2 }}>
                <Typography>
                  7. ¿Alguno de sus créditos está avalado?
                </Typography>
                <RadioGroup
                  row
                  value={form?.credito_avalado ?? ""}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      credito_avalado: e.target.value,
                    }))
                  }>
                  <FormControlLabel
                    value="Si"
                    control={<Radio />}
                    label="Si"
                    disabled={status !== 0}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio />}
                    label="No"
                    disabled={status !== 0}
                  />
                </RadioGroup>
              </Box>
              {/* {console.log(form)} */}
              {/* Hidden date fields behavior follows original: date_firma_form on initial present, date_edit_firma_form on edit */}
              {(activeTask?.status === 0 || status === 0) &&
                !form?.date_firma_form && (
                  <input
                    type="hidden"
                    name="date_firma_form"
                    value={`Presentado con fecha:${new Date()
                      .toISOString()
                      .slice(0, 19)
                      .replace("T", " ")}`}
                  />
                )}

              {(activeTask?.status === 1 || status === 1) && (
                <Box sx={{ mt: 2 }}>
                  <input
                    type="hidden"
                    name="date_edit_firma_form"
                    value={
                      form?.date_edit_firma_form ||
                      `Fecha última modificación:${new Date()
                        .toISOString()
                        .slice(0, 19)
                        .replace("T", " ")}`
                    }
                  />
                  <Paper variant="outlined" sx={{ p: 2, mt: 1 }}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${
                          form?.date_firma_form
                            ? form?.date_firma_form + "<br/><br/>"
                            : ""
                        }Fdo: D./Dª ${form?.nombre_completo || "No se ha escrito un nombre"} <br/><br/>${
                          form?.date_edit_firma_form || ""
                        }`,
                      }}
                    />
                  </Paper>
                </Box>
              )}

              <Box
                sx={{
                  mt: 3,
                  display: "flex",
                  justifyContent: "space-between",
                }}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Save />}
                  onClick={handleDownloadPDF}
                  sx={{
                    background:
                      "linear-gradient(135deg, #1976d2 0%, #004ba0 100%)",
                    color: "#fff",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #1565c0 0%, #003c8f 100%)",
                    },
                  }}>
                  Descargar PDF
                </Button>

                {canSignFi && (
                  <Box sx={{ display: "flex", gap: 3 }}>
                    <Button
                      variant="contained"
                      disabled={status !== 0}
                      color="info"
                      startIcon={<Update />}
                      onClick={saveDraft}>
                      Editar borrador
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      disabled={status !== 0 || activeTask?.status !== 0}
                      endIcon={<ArrowForwardIosOutlined />}
                      onClick={submitForm}>
                      Enviar
                    </Button>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}
